/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from 'react';
import ReactLoading from 'react-loading';
import ThemeContext from 'contexts/ThemeContext';
import IconButton from '@material-ui/core/IconButton';
import Alert from '@mui/material/Alert';
import api from 'api';

import { SideMenu, SectionTitle, Input, Button } from 'components';
import {
  Container,
  ContentArea,
  TitleArea,
  FeaturesArea,
  PermissionSection,
} from './styles';
import { toast } from 'react-toastify';
import { BsArrowLeft } from 'react-icons/bs';
import { formatRoleCategory } from 'utils/userCategory';

function Update({ history, location }) {
  const dataId = parseInt(location.pathname.split('/perfil-de-acesso/')[1]);
  const [loading, setLoading] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [data, setData] = useState();
  const [featuresData, setFeaturesData] = useState();
  const { primary, loadingColor } = useContext(ThemeContext);

  const categories = [
    ...new Set(featuresData?.map((feature) => feature.category)),
  ]
    .filter((i) => i !== 'user')
    .sort();

  const loadData = async () => {
    setLoading(true);
    const respFeatures = await api.get(`/list-features`);
    setFeaturesData(respFeatures.data);

    const resp = await api.get(`/role/${dataId}`);
    setData({ ...resp.data, features: resp.data.features.map((i) => i.id) });
    setLoading(false);
  };

  const handleUpdate = async () => {
    setLoadingUpdate(true);

    try {
      await api.put(`/role/${dataId}`, {
        ...data,
      });

      setLoadingUpdate(false);
      toast.success('Alterações realizadas com sucesso!');
      loadData();
    } catch (e) {
      setLoadingUpdate(false);
      toast.error(e?.response?.data?.error);
    }
  };

  const handleChangeFeature = async (feature) => {
    const isChecked = data?.features?.findIndex((i) => i === feature) > -1;
    const currentFeaturesList = [...data?.features];
    if (isChecked) {
      currentFeaturesList.splice(
        currentFeaturesList.findIndex((listItem) => listItem === feature),
        1
      );
      setData({ ...data, features: currentFeaturesList });
    } else {
      currentFeaturesList.push(feature);
      setData({ ...data, features: currentFeaturesList });
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Container>
      <SideMenu />
      {loading && (
        <div className="loading-area">
          <ReactLoading
            type="spin"
            color={loadingColor}
            height={45}
            width={45}
          />
        </div>
      )}
      {!loading && (
        <ContentArea>
          <section>
            <TitleArea>
              <IconButton
                style={{ maerginRight: 5 }}
                onClick={() => history?.push('/perfis-de-acesso')}>
                <BsArrowLeft size={16} />
              </IconButton>
              <h1>Perfil de acesso</h1>
            </TitleArea>

            {!data?.id_company && (
              <Alert severity="warning" style={{ marginTop: 30, width: 380 }}>
                Não é possível editar perfis de acesso públicos!
              </Alert>
            )}

            <div>
              <SectionTitle color={primary} title=" Editar informações" />

              <div className="form">
                <Input
                  label="Nome"
                  height="35px"
                  width="380px"
                  disabled={!data?.id_company}
                  value={data?.name}
                  onChange={(e) => setData({ ...data, name: e.target.value })}
                />

                <Input
                  label="Descrição"
                  height="35px"
                  width="380px"
                  disabled={!data?.id_company}
                  value={data?.description}
                  onChange={(e) =>
                    setData({ ...data, description: e.target.value })
                  }
                />

                <SectionTitle color={primary} title=" Permissões" />

                <FeaturesArea>
                  {categories?.map((category) => (
                    <PermissionSection>
                      <h3>{formatRoleCategory(category)}</h3>
                      <div className="items-list">
                        {featuresData
                          ?.filter((f) => f.category === category)
                          ?.map((feature) => (
                            <div className="checkbox-item">
                              <input
                                className="label"
                                type="checkbox"
                                id={feature?.id}
                                name={feature?.id}
                                disabled={!data?.id_company}
                                checked={
                                  data?.features?.findIndex(
                                    (i) => i === feature.id
                                  ) > -1
                                }
                                onChange={() =>
                                  handleChangeFeature(feature?.id)
                                }
                              />
                              <div className="label-group">
                                <label for={feature?.id}>
                                  {feature?.name}
                                  <small>{feature?.description}</small>
                                </label>
                              </div>
                            </div>
                          ))}
                      </div>
                    </PermissionSection>
                  ))}
                </FeaturesArea>

                {data?.id_company && (
                  <Button
                    style={{ marginTop: 30 }}
                    height="35px"
                    width="380px"
                    loading={loadingUpdate}
                    disabled={
                      loadingUpdate ||
                      !data?.name ||
                      !data?.description ||
                      data?.features?.length < 1
                    }
                    onClick={handleUpdate}>
                    Salvar alterações
                  </Button>
                )}
              </div>
            </div>
          </section>
        </ContentArea>
      )}
    </Container>
  );
}

export default Update;
